import { useCallback, useEffect, useState } from "react";
import { Check, Trash2, X } from "lucide-react";
import { toast } from "sonner";
import { useStore } from "@/context/Store";
import { http, imgUrl } from "@/lib/api";
import { Stars } from "@/components/site/ReviewForm";

const LABEL = { pending: "Por aprovar", approved: "Publicadas", rejected: "Rejeitadas" };

export default function AdminReviews() {
  const { reload } = useStore();
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState("pending");
  const load = useCallback(() => http.get("/admin/reviews").then((r) => setList(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const moderate = async (r, status) => { await http.patch(`/admin/reviews/${r.id}`, { status }); toast.success(status === "approved" ? "Avaliação publicada" : "Avaliação rejeitada"); load(); reload(); };
  const remove = async (r) => { if (!window.confirm("Apagar esta avaliação?")) return; await http.delete(`/admin/reviews/${r.id}`); load(); reload(); };
  const shown = list.filter((r) => r.status === filter);

  return (
    <div data-testid="admin-reviews">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="font-display text-3xl font-bold">Avaliações</h2>
        <div className="flex gap-2">{Object.entries(LABEL).map(([k, l]) => <button key={k} data-testid={`admin-reviews-filter-${k}`} onClick={() => setFilter(k)} className={`rounded-full px-4 py-1.5 text-sm ${filter === k ? "bg-[var(--ink)] text-white" : "border border-[var(--line)] bg-white"}`}>{l} ({list.filter((r) => r.status === k).length})</button>)}</div>
      </div>
      {!shown.length && <p className="mt-10 text-center text-sm text-[var(--muted-ink)]" data-testid="admin-reviews-empty">Sem avaliações nesta lista.</p>}
      <div className="mt-6 grid gap-4 lg:grid-cols-2">
        {shown.map((r) => (
          <article key={r.id} className="rounded-2xl border border-[var(--line)] bg-white p-5" data-testid={`admin-review-${r.id}`}>
            <div className="flex flex-wrap items-center gap-2"><b>{r.name}</b><Stars value={r.rating} /><span className="ml-auto text-xs text-[var(--muted-ink)]">{new Date(r.created_at).toLocaleDateString("pt-PT")}</span></div>
            <p className="mt-1 text-xs text-[var(--violet)]">{r.product_name} · pedido {r.order_number}</p>
            <p className="mt-3 text-sm">{r.text}</p>
            {r.photos?.length > 0 && <div className="mt-3 flex gap-2">{r.photos.map((p) => <a key={p} href={imgUrl(p)} target="_blank" rel="noreferrer"><img src={imgUrl(p)} alt="" className="h-20 w-20 rounded-xl object-cover" /></a>)}</div>}
            <div className="mt-4 flex gap-2">
              {r.status !== "approved" && <button data-testid={`admin-review-approve-${r.id}`} onClick={() => moderate(r, "approved")} className="btn-primary !px-4 !py-2"><Check className="h-4 w-4" />Publicar</button>}
              {r.status !== "rejected" && <button data-testid={`admin-review-reject-${r.id}`} onClick={() => moderate(r, "rejected")} className="btn-ghost !px-4 !py-2"><X className="h-4 w-4" />{r.status === "approved" ? "Ocultar" : "Rejeitar"}</button>}
              <button data-testid={`admin-review-delete-${r.id}`} onClick={() => remove(r)} className="ml-auto rounded-full p-2 hover:bg-red-50 hover:text-red-600" aria-label="Apagar"><Trash2 className="h-4 w-4" /></button>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
